import { baseRoute } from '../../constants/routes';

export const RESET_PASSWORD_ROUTE = baseRoute + '/reset-password';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';